import { 
  FetchFieldsParamsParams, 
  FetchFieldsParamsResponse 
} from "../types/filter";

import API from "@/services/api";
import { EndpointsFilter } from "./endpoints";

export const fetchFieldParams = ({
  fields,
  type
}: FetchFieldsParamsParams) => {
  return new Promise<FetchFieldsParamsResponse>(async (resolve, reject) => {
    API.get<FetchFieldsParamsResponse>({
      endpoint: EndpointsFilter.FieldParams,
      versions: [2],
      searchParams: [
        '?fields', '=', fields.join(','),
        '&type', '=', type,
      ].join(''),
      config: {
        headers: {
          "Content-Type": "application/json"
        }
      }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchFieldParams
};